import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import { connect, ReactReduxContext, Provider } from "react-redux";
import { clearStripeError, showStripeError } from "redux/modules/billing";
import { createNewPartnerLocation, setFormValue } from "redux/modules/newClient";
import { submitNewClientForm, getPartnerDetailsByPartnerOrgId } from "redux/modules/teamManagement";
import Dialog from "material-ui/Dialog";
import RaisedButton from "material-ui/RaisedButton";
import NewLocation from "../NewLocation/NewLocation";
import NewClientSuccess from "../NewClient/NewClientSuccess";
import tallyClientTotals from "../../../helpers/newClientSummaryTotals";
import { EmptyState, Spinner } from "components";
import * as styles from "./NewLocation.scss";
var NewLocationWrap = (_dec = connect(function (state) {
  return {
    auth: state.auth,
    config: state.config,
    organization: state.organization.current,
    theme: state.theme,
    step1Valid: state.newClient.validation.step1Valid,
    step2Valid: state.newClient.validation.step2Valid,
    formValues: _objectSpread(_objectSpread({}, state.newClient), {}, {
      orgConfig: _objectSpread(_objectSpread({}, state.newClient.orgConfig), {}, {
        managementFee: 99 // static management fee for locations

      })
    }),
    step2FirstPass: state.newClient.validation.step2FirstPass,
    hasCommissionsAccount: state.billing.hasCommissionsAccount,
    loadingHasCommissionsAccount: state.billing.loadingHasCommissionsAccount,
    submittingNewClient: state.newClient.submittingNewClient
  };
}, {
  clearStripeError: clearStripeError,
  createNewPartnerLocation: createNewPartnerLocation,
  setFormValue: setFormValue,
  showStripeError: showStripeError,
  submitNewClientForm: submitNewClientForm,
  getPartnerDetailsByPartnerOrgId: getPartnerDetailsByPartnerOrgId
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewLocationWrap, _Component);

  var _super = _createSuper(NewLocationWrap);

  function NewLocationWrap(props) {
    var _this2;

    _classCallCheck(this, NewLocationWrap);

    _this2 = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "handleAddClientClick", function () {
      _this2.setState({
        newOrg: null,
        showNewClientDialog: true
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "handleStep2NextClick", function () {
      if (!_this2.state.creationInProgress) {
        _this2.setState({
          creationInProgress: true
        });
      }

      var _this2$props$formValu = _this2.props.formValues,
          orgConfig = _this2$props$formValu.orgConfig,
          orgDetails = _this2$props$formValu.orgDetails; // time to show any error messages on form

      if (_this2.props.step2FirstPass) {
        _this2.props.setFormValue("step2FirstPass", "validation", false);
      } // validate form
      //            this.props.validateForm();
      // do stripe part


      if (_this2.props.step2Valid) {
        var partnerPaysAll = _this2.props.formValues && _this2.props.formValues.locationBillingInfo && (_this2.props.formValues.locationBillingInfo.licenseFeeBillTo === "partner" || _this2.props.formValues.locationBillingInfo.licenseFeeBillTo === "existing") && _this2.props.formValues.locationBillingInfo.adsBillTo === "partner";

        if (partnerPaysAll) {
          _this2.setState({
            newClientFormStep: _this2.state.newClientFormStep + 1
          });
        } else {
          console.log("W#$*#*@#*$&&$#&");
          console.log("W#$*#*@#*$&&$#&");
          console.log("in else where it should not be");
          console.log("partnerPaysAll = ".concat(partnerPaysAll));

          _this2.handleConnectCC().then(function (stripeRes) {
            _this2.props.setFormValue("stripeTokenId", "cc", stripeRes.id);

            _this2.setState({
              newClientFormStep: _this2.state.newClientFormStep + 1
            });
          });
        }
        /* else {
        // create using existing license
        const data = {
          contract: {
            firstName: orgDetails.firstName,
            lastName: orgDetails.lastName,
            email: orgDetails.email,
            businessName: orgDetails.businessName,
            phone: orgDetails.phone
          },
          address: {
            address1: orgDetails.address1,
            address2: orgDetails.address2,
            region: orgDetails.city,
            postcode: orgDetails.zipCode,
            locality: orgDetails.state
          },
          productId: 5
        };
         this.props.submitNewClientForm(this.props.theme.org, data).then(res => {
          this.setState({
            newOrg: res && res.data ? res.data : null,
            showNextStepsDialog: true,
            newClientFormStep: 1,
            showNewClientDialog: false,
            creationInProgress: false
          });
        });
        }*/

      }
    });

    _defineProperty(_assertThisInitialized(_this2), "handleConnectCC", function () {
      var _this2$props$formValu2 = _this2.props.formValues,
          cc = _this2$props$formValu2.cc,
          orgDetails = _this2$props$formValu2.orgDetails;

      _this2.setState({
        checkoutInProgress: true
      });

      var _this = _assertThisInitialized(_this2);

      var stripePaymentObject = Stripe.card;
      return new Promise(function (resolve, reject) {
        stripePaymentObject.createToken({
          number: cc.cardNumber,
          exp_month: cc.expMonth,
          exp_year: cc.expYear,
          cvc: cc.cvc,
          name: orgDetails.name,
          address_zip: orgDetails.zipCode
        }, function (status, response) {
          _this.setState({
            checkoutInProgress: false
          });

          if (response.error) {
            return _this2.props.showStripeError(response.error);
          }

          if (status === 200) {
            console.log("it appears the stripe bit worked");

            _this2.props.clearStripeError();

            _this2.props.setFormValue("cardDetails", "cc", response.card);

            resolve(response);
          }

          console.log(status, response);
        });
      });
    });

    Stripe.setPublishableKey(_this2.props.config.stripePublicKey);
    _this2.state = {
      newOrg: null,
      showNextStepsDialog: false,
      showNewClientDialog: false,
      newClientFormStep: 1,
      checkoutInProgress: false,
      creatingNewClient: false,
      creationInProgress: false
    };
    return _this2;
  }

  _createClass(NewLocationWrap, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setFormValue("step2Valid", "validation", true);
      this.props.setFormValue("step2FirstPass", "validation", true);
      this.props.setFormValue("managementFee", "orgConfig", 200);
    }
    /** *******************************************************************************************
     EVENT HANDLERS
    ********************************************************************************************/

  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this3 = this;

      var _this$props = this.props,
          contractInfo = _this$props.contractInfo,
          formValues = _this$props.formValues;
      var _this$props$formValue = this.props.formValues,
          orgConfig = _this$props$formValue.orgConfig,
          orgDetails = _this$props$formValue.orgDetails;
      var totals = contractInfo && orgConfig ? tallyClientTotals(contractInfo, orgConfig) : {};
      var connectCommissionsAccountActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Close",
        onClick: function onClick() {
          _this3.setState({
            showNewClientDialog: false,
            newClientFormStep: 1
          });
        },
        style: {
          marginRight: 24
        }
      })]; // CANCEL BUTTON

      var newClientDialogActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          _this3.setState({
            showNewClientDialog: false,
            newClientFormStep: 1
          });

          _this3.props.clearStripeError();
        },
        style: {
          marginRight: 24
        }
      })]; // BACK BUTTON

      if (this.state.newClientFormStep > 1) {
        newClientDialogActions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          label: "Back",
          onClick: function onClick() {
            _this3.setState({
              newClientFormStep: _this3.state.newClientFormStep - 1
            });
          },
          style: {
            marginRight: 24
          }
        }));
      }

      if (this.state.newClientFormStep === 1) {
        newClientDialogActions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          disabled: !this.props.step1Valid,
          secondary: true,
          label: "Next",
          onClick: function onClick() {
            _this3.setState({
              newClientFormStep: _this3.state.newClientFormStep + 1
            });
          }
        }));
      } else if (this.state.newClientFormStep === 2) {
        newClientDialogActions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          secondary: true,
          disabled: !this.props.step2Valid && !this.props.step2FirstPass && !this.props.submittingNewClient,
          label: "Next",
          onClick: this.handleStep2NextClick
        }));
      } else if (this.state.newClientFormStep === 3) {
        newClientDialogActions.push( /*#__PURE__*/React.createElement(RaisedButton, {
          secondary: true,
          disabled: this.state.creatingNewClient,
          label: this.state.creatingNewClient ? /*#__PURE__*/React.createElement("i", {
            className: "fa fa-spinner fa-spin",
            style: {
              fontSize: 20
            }
          }) : "Finish",
          onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var data, newOrgRes;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;

                    _this3.setState({
                      creatingNewClient: true
                    }); // create the org


                    data = Object.assign({}, _this3.props.formValues);
                    _context.next = 5;
                    return _this3.props.createNewPartnerLocation(_this3.props.theme.org, data);

                  case 5:
                    newOrgRes = _context.sent;

                    _this3.setState({
                      newOrg: newOrgRes && newOrgRes.data && newOrgRes.data.org ? newOrgRes.data.org : null,
                      showNextStepsDialog: true,
                      creatingNewClient: false,
                      newClientFormStep: 1,
                      showNewClientDialog: false
                    });

                    _context.next = 9;
                    return _this3.props.getPartnerDetailsByPartnerOrgId(_this3.props.theme.org);

                  case 9:
                    _context.next = 15;
                    break;

                  case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](0);
                    console.error(_context.t0);

                    _this3.setState({
                      creatingNewClient: false
                    });

                  case 15:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 11]]);
          }))
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column"
        }
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Add Location",
        style: {
          marginRight: 32
        },
        onClick: this.handleAddClientClick
      }), /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dialog, {
          contentStyle: {
            maxWidth: 990,
            width: "97%"
          },
          title: "Add A New Location",
          autoScrollBodyContent: true,
          actions: newClientDialogActions,
          modal: true,
          open: _this3.state.showNewClientDialog
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(NewLocation, {
          totals: totals,
          contractInfo: contractInfo,
          formStep: _this3.state.newClientFormStep
        }))), /*#__PURE__*/React.createElement(Dialog, {
          actions: [/*#__PURE__*/React.createElement(RaisedButton, {
            label: "Close",
            onClick: function onClick() {
              _this3.setState({
                showNextStepsDialog: false
              });
            }
          })],
          title: "Next Steps",
          autoScrollBodyContent: true,
          open: _this3.state.showNextStepsDialog
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(NewClientSuccess, {
          newOrg: _this3.state.newOrg
        }))));
      }));
    }
  }]);

  return NewLocationWrap;
}(Component)) || _class);
export { NewLocationWrap as default };